import { ApiMethod } from 'services/api';
import {
  RestQueryHookOptions,
  useRestMutation,
  UseRestMutationOptions,
  useRestQuery,
} from 'utils/hooks/api';
import { MessageMedium } from 'constants/messageMediums';

export const FETCH_CHANNELS_URL = '/settings/channels.json';
export const CREATE_CHANNEL_URL = '/settings/channels/create';
export const DELETE_CHANNEL_URL = '/settings/channels/delete';
export const UPDATE_CHANNEL_URL = '/settings/channels/update';

export const useChannelsQuery = (options?: RestQueryHookOptions) =>
  useRestQuery(FETCH_CHANNELS_URL, {}, options);
export const useCreateChannelMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_CHANNEL_URL, ApiMethod.post, options);
export const useDeleteChannelMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(DELETE_CHANNEL_URL, ApiMethod.post, options);
export const useUpdateChannelMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_CHANNEL_URL, ApiMethod.post, options);

export enum ChannelType {
  Marketing = 'Marketing',
  Transactional = 'Transactional',
}

export type EspBinding = {
  espAccountId: number;
  trafficPercentage: number;
};

export type FrequencyManagement = {
  _type: string;
  numSendsAllowed: number;
  period: string;
};

export type Channel = {
  channelType: ChannelType;
  createdAt: number;
  creatorUserId: string;
  espBindings?: EspBinding[];
  frequencyManagement?: FrequencyManagement;
  id: number;
  messageMedium: MessageMedium;
  name: string;
  projectId: number;
  updatedAt: number;
};
